/**
 * Text Area Section - Mobile Read More Functionality
 * Handles text truncation and expansion for mobile devices only
 * Also handles collection banner read more buttons
 * 
 * @version 1.1.0
 */

(function() {
  'use strict';
  
  /**
   * Initialize all read more functionality
   */
  function initReadMore() {
    // Find all mobile-truncate-text containers (collection banner + text area sections)
    const containers = document.querySelectorAll('.mobile-truncate-text');
    
    if (containers.length === 0) {
      return;
    }
    
    containers.forEach(function(container) {
      const contentDiv = container.querySelector('[data-full-text]');
      const button = container.querySelector('.read-more-btn');
      
      if (!contentDiv || !button) {
        return;
      }
      
      // Check if already initialized
      if (button.dataset.initialized === 'true') {
        return;
      }
      
      // Mark as initialized
      button.dataset.initialized = 'true';

      // Check if we're on mobile (viewport width < 750px)
      const isMobile = window.innerWidth < 750;

      // Set initial truncated state using max-height (mobile only)
      if (isMobile) {
        contentDiv.style.maxHeight = '4.2em'; // Approximately 3 lines
        contentDiv.style.overflow = 'hidden';
        contentDiv.style.position = 'relative';
      } else {
        // On desktop, remove any truncation
        contentDiv.style.maxHeight = 'none';
        contentDiv.style.overflow = 'visible';
      }

      // Add click listener (only functional on mobile)
      button.addEventListener('click', function(event) {
        event.preventDefault();

        // Only allow toggling on mobile
        const isMobile = window.innerWidth < 750;
        if (!isMobile) {
          return;
        }

        // Toggle expanded state
        if (contentDiv.classList.contains('expanded')) {
          // Collapse
          contentDiv.classList.remove('expanded');
          contentDiv.style.maxHeight = '4.2em';
          button.textContent = 'Read more';
          button.setAttribute('aria-label', 'Read more');
          button.setAttribute('aria-expanded', 'false');

          // Scroll back to section for better UX
          const section = container.closest('.text-area, .collectionBanner');
          if (section) {
            const sectionTop = section.getBoundingClientRect().top + window.scrollY;
            const offset = 100;

            window.scrollTo({
              top: sectionTop - offset,
              behavior: 'smooth'
            });
          }
        } else {
          // Expand
          contentDiv.classList.add('expanded');
          contentDiv.style.maxHeight = 'none';
          button.textContent = 'Read less';
          button.setAttribute('aria-label', 'Read less');
          button.setAttribute('aria-expanded', 'true');
        }
      });
      
      // Add keyboard support
      button.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          button.click();
        }
      });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    // DOM already loaded
    initReadMore();
  }
  
  // Re-initialize on Shopify section events (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      // Small delay to ensure DOM is updated
      setTimeout(initReadMore, 100);
    });
    
    document.addEventListener('shopify:section:unload', function() {
      // Clean up if needed
      const buttons = document.querySelectorAll('.read-more-btn[data-initialized="true"]');
      buttons.forEach(function(button) {
        button.dataset.initialized = 'false';
      });
    });
  }
})();